import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../../jsx/global-functions/checkErrors";
export const getHomeDataFunc = createAsyncThunk(
    "get home data function",
    async (api) => {
        const token = window.localStorage.getItem("token")
        const config = {
            headers: {
                Authorization: `Bearer ${token}` // Include the token in the Authorization header
            }
        }
        try {
            const response = await axios.get(api , config);
            if(response && response.data) {
                const homeDataObj = response.data.data
                window.localStorage.setItem("homeObj" , JSON.stringify(homeDataObj))
            }
            return response.data.data;
        }
        catch (error) {
            checkErrors(error.response , error.message);
        }
        
    }
)

const getHomeDataSlicer = createSlice({
    name : "get home data slicer",
    initialState : {
        loading : null,
        data : null,
        error : null
    },
    reducer : {},
    extraReducers : (builder) => {
        builder.addCase(getHomeDataFunc.pending , (state) => {
            state.loading = true
            state.data = null
            state.error = null
        })
        builder.addCase(getHomeDataFunc.rejected , (state) => {
            state.loading = null
            state.data = null
            state.error = true
        })
        builder.addCase(getHomeDataFunc.fulfilled , (state , action) => {
            state.loading = false
            state.data = action.payload
            state.error = null
        })
    }
})

export default getHomeDataSlicer.reducer;